import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import List from "../../core/list/List";
import ListItem from "../../core/list/ListItem";
import DropdownList from "../dropdownButton/DropdownList";

const Wrapper = styled.div`
  width: 100%;
`;
interface SelectGroupProps {
  options: { value: string; label: string }[];
  value: string;
  onChange?: (e: string | string[]) => void;
  type?: "radio" | "checkbox";
  size?: "sm" | "md" | "lg";
  maxChoices?: number;
  minChoices?: number;
}
const SelectGroup: FC<SelectGroupProps> = ({
  options,
  value,
  onChange,
  type = "radio",
  size = "md" as const,
  ...props
}) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState<string | string[]>(value);
  const toggle = (array: string[], val: string) => {
    if (!Array.isArray(array)) return [val];
    return array?.includes(val)
      ? array?.filter((c: string) => c !== val)
      : [...array, val];
  };
  const handleClick = (val: string) => {
    const newValue =
      type === "checkbox" ? toggle(checked as string[], val) : val;
    setChecked(newValue);
    onChange?.(newValue);
  };
  const check = (c: string | string[], v: string) => {
    if (type === "checkbox") {
      return c?.includes(v);
    }
    return c === v;
  };
  const disabled = (c: string | string[], v: string) =>
    props.maxChoices && checked?.length >= props.maxChoices && !check(c, v);

  return (
    <Wrapper {...props}>
      {/* <DropdownList
        data={options?.map((item, index) => ({
          type,
          checked: check(checked, item.value),
          text: item.label,
          label: item.label,
          onClick: () => handleClick(item.value),
          maxWidth: "100%",
          disabled: disabled(checked, item.value),
          disabledNotice: `Maximum of ${props.maxChoices} answers reached`,
          "data-cy": `selectGroup-index-${index}`,

          ...item,
        }))}
        options={{ size }}
        name={props.name}
      /> */}

      {/* <List
        data={options?.map((item, index) => (
          <ListItem
            id={item?.layerTitle}
            tag="div"
            primaryContent={item?.layerTitle}
            selectable
          />
        ))}
      /> */}
      <div className="flex flex-col gap-1">
        {options?.map((item, index) => {
          return (
            <ListItem
              id={item?.value}
              key={item?.value}
              primaryContent={item?.label}
              selectable
              selectableType={type}
              onClick={() => handleClick(item.value)}
              selected={check(checked, item.value)}
              // classNames={{ base: "h-auto min-h-16" }}
              classNames={{
                base: "m-0 h-auto min-h-[38px] cursor-pointer px-2 py-1",
              }}
              disabled={disabled(checked, item.value)}
              disabledNotice={t("survey:disabledMessages.radio.maxChoices", {
                count: props.maxChoices,
              })}
            />
          );
        })}
      </div>
    </Wrapper>
  );
};
export default SelectGroup;
